
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { BusinessUnitOverviewDto_$reflection } from "../Shared/BusinessUnit.js";
import { lambda_type, unit_type, string_type, union_type, class_type, record_type, option_type, list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { BusinessUnitId, BusinessUnitId__get_unwrap, RequestedValue$1, BusinessUnitId_$reflection, RequestedValue$1_$reflection } from "../Shared/Shared.js";
import { User_$reflection } from "../Shared/User.js";
import { getBusinessUnits } from "../Requests/BusinessUnit.js";
import { forAll, length, cons, singleton as singleton_1, ofArray, tryHead, map, contains, filter, isEmpty, empty } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { defaultOf as defaultOf_1, equals, int32ToString, createObj, stringHash } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { unwrap, map as map_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { parse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { map as map_2, empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextValue } from "../Components/Text.js";
import { InformationAlert, WarningAlert, ErrorAlert } from "../Components/Alert.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Button, TextButton } from "../Components/Button.js";
import { nativeType, useDrop } from "../Bindings/Fable.ReactDnD.js";
import { item, equalsWith } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { toList as toList_1, FSharpMap__get_Item } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { BusinessUnitSelect } from "./BusinessUnitSelect.js";
import { Checkbox } from "../Components/Checkbox.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Skeleton } from "../Components/Skeleton.js";
import { SectionContainer } from "./Container.js";

class State extends Record {
    constructor(BusinessUnits, UserBusinessUnits, CurrentUser, SelectedBusinessUnitId) {
        super();
        this.BusinessUnits = BusinessUnits;
        this.UserBusinessUnits = UserBusinessUnits;
        this.CurrentUser = CurrentUser;
        this.SelectedBusinessUnitId = SelectedBusinessUnitId;
    }
}

function State_$reflection() {
    return record_type("Widgets.Importer.State", [], State, () => [["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["UserBusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["CurrentUser", User_$reflection()], ["SelectedBusinessUnitId", option_type(BusinessUnitId_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BusinessUnitsFetched", "SelectBusinessUnitId", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Importer.Msg", [], Msg, () => [[["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [["Item", option_type(BusinessUnitId_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

function init(currentUser, accountSettings) {
    if (accountSettings.BusinessUnitsEnabled) {
        return [new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), currentUser, undefined), getBusinessUnits((Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1])))];
    }
    else {
        return [new State(new RequestedValue$1(1, [empty()]), new RequestedValue$1(1, [empty()]), currentUser, undefined), Cmd_none()];
    }
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.BusinessUnits, state.UserBusinessUnits, state.CurrentUser, msg.fields[0]), Cmd_none()];
        case 2:
            return [state, Cmd_none()];
        default: {
            const businessUnits = msg.fields[0];
            const usersBusinessUnits = isEmpty(state.CurrentUser.BusinessUnitIds) ? businessUnits : filter((businessUnit) => contains(businessUnit.Id, map(BusinessUnitId__get_unwrap, state.CurrentUser.BusinessUnitIds), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }), businessUnits);
            return [new State(new RequestedValue$1(1, [businessUnits]), new RequestedValue$1(1, [usersBusinessUnits]), state.CurrentUser, isEmpty(state.CurrentUser.BusinessUnitIds) ? undefined : map_1((arg_1) => (new BusinessUnitId(parse(arg_1.Id))), tryHead(usersBusinessUnits))), Cmd_none()];
        }
    }
}

export class TemplateType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LocalCsv", "DownloadApi"];
    }
}

export function TemplateType_$reflection() {
    return union_type("Widgets.Importer.TemplateType", [], TemplateType, () => [[["Item", string_type]], [["Item", lambda_type(unit_type, unit_type)]]]);
}

export function FailedTd(props) {
    let elems;
    const patternInput = useTranslation();
    return reactElement("td", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("bg-light-red"), delay(() => props.ColClasses)))))], (elems = [props.Value, createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: patternInput[0](props.ToolTipMsg),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function TdString(props) {
    const matchValue = props.ValidatedCell.ValidationResult;
    if (matchValue.tag === 1) {
        return createElement(FailedTd, {
            ColClasses: props.ColClasses,
            ToolTipMsg: matchValue.fields[0],
            Value: props.ValidatedCell.Value,
        });
    }
    else {
        return reactElement("td", {
            className: join(" ", toList(delay(() => props.ColClasses))),
            children: props.ValidatedCell.Value,
        });
    }
}

function OptionalAlert(props) {
    let elems;
    const patternInput = useTranslation();
    const matchValue = props.ValidatedCell.ValidationResult;
    if (matchValue.tag === 1) {
        const msg_1 = patternInput[0](matchValue.fields[0]);
        return reactElement("div", createObj(ofArray([["className", join(" ", ["w-[35rem]", "p-2"])], (elems = [createElement(ErrorAlert, {
            Label: `${int32ToString(props.Index)} | ${props.Header} | ${msg_1}`,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return defaultOf();
    }
}

export function DownloadFileArea(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems = toList(delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("importer.file_template"),
    })), delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("importer.file_download_description"),
    })), delay(() => append(singleton(createElement(TextButton, {
        ComponentState: "enabled",
        Label: t("importer.tool_help_text"),
        OnClick: () => {
            let matchValue;
            window.open((matchValue = props.CurrentUserLanguage, (matchValue === "en") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : ((matchValue === "fr") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : ((matchValue === "it") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : ((matchValue === "uk") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : ((matchValue === "nl") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : ((matchValue === "pl") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : ((matchValue === "hr") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : ((matchValue === "ro") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : ((matchValue === "sr") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : ((matchValue === "sq") ? "https://help.inventory-one.com/knowledge-base-en/administration#import-export" : "https://help.inventory-one.com/knowledge-base/administration#import-export")))))))))), "_blank", "noreferrer");
        },
        TestId: "widgets-importer-toolhelp-button",
        Variant: "default",
    })), delay(() => {
        const matchValue_1 = props.CsvFileName;
        return (matchValue_1.tag === 1) ? singleton(createElement(TextButton, {
            ComponentState: "enabled",
            Label: "Download",
            OnClick: matchValue_1.fields[0],
            TestId: "download-template",
            Variant: "blueButton",
        })) : singleton(reactElement("a", {
            "data-test-id": "download-template",
            className: join(" ", ["text-primary-link", "flex", "items-center", "cursor-pointer", "text-sm", "font-medium"]),
            href: concat("/assets/templates/", ...matchValue_1.fields[0]),
            download: true,
            children: "Download",
        }));
    })))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function UploadArea(props) {
    let elems_1, elems;
    const patternInput = useTranslation();
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let testExpr, testExpr_1;
            const matchValue = draggedFile.files;
            if (matchValue == null) {
            }
            else if ((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf_1()) && (testExpr.length === 0))) {
            }
            else if ((testExpr_1 = matchValue, !equalsWith(equals, testExpr_1, defaultOf_1()) && (testExpr_1.length === 1))) {
                const file = item(0, matchValue);
                if ((props.ComponentState === "enabled") && ("text/csv" === file.type)) {
                    props.OnFile(file);
                }
            }
        },
    });
    const dropData = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: "Upload",
    }), reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("border"), delay(() => append(singleton("rounded"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => append(singleton("p-4"), delay(() => ((dropData.isOver && dropData.canDrop) ? singleton("bg-background") : empty_1()))))))))))))))], ["ref", patternInput_1[1]], (elems = [createElement(TextButton, {
        ComponentState: props.ComponentState,
        Label: patternInput[0]("file_upload.select_file"),
        OnClick: () => {
            const element = document.getElementById("file-upload");
            element.click();
        },
        TestId: "open-file-explorer-test-id",
        Variant: "blueButton",
    }), reactElement("input", {
        id: "file-upload",
        className: join(" ", ["hidden"]),
        type: "file",
        accept: ".csv, .CSV",
        disabled: props.ComponentState === "disabled",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                props.OnFile(files.item(0));
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function FailResultArea(props) {
    const rowList = map((index) => {
        const children = map((header) => createElement(OptionalAlert, {
            Header: header,
            Index: index,
            ValidatedCell: FSharpMap__get_Item(props.Data.Rows, [index, header]),
        }), props.Data.Headers);
        return reactElement("li", {
            children: reactApi.Children.toArray(Array.from(children)),
        });
    }, toList(rangeDouble(2, 1, props.Data.RowsLength)));
    const children_5 = singleton_1(reactElement("ul", {
        children: reactApi.Children.toArray(Array.from(rowList)),
    }));
    return reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children_5)),
    });
}

export function ResultArea(props) {
    let elems_1, elems, children_5;
    const headerClasses = ofArray(["p-4", "border-b", "border-border"]);
    const colClasses = ofArray(["p-4", "border-b", "border-border"]);
    const header = cons(reactElement("th", {
        className: join(" ", toList(delay(() => headerClasses))),
        children: "Zeile",
    }), toList(delay(() => map_2((value_3) => reactElement("th", {
        className: join(" ", toList(delay(() => headerClasses))),
        children: value_3,
    }), props.Data.Headers))));
    const rowList = map((number) => {
        const children = cons(reactElement("td", {
            className: join(" ", toList(delay(() => colClasses))),
            children: `${number}`,
        }), map((header_1) => createElement(TdString, {
            ColClasses: colClasses,
            ValidatedCell: FSharpMap__get_Item(props.Data.Rows, [number, header_1]),
        }), props.Data.Headers));
        return reactElement("tr", {
            children: reactApi.Children.toArray(Array.from(children)),
        });
    }, toList(rangeDouble(2, 1, props.Data.RowsLength)));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["overflow-x-auto", "bg-white", "rounded", "p-6"])], (elems_1 = [reactElement("table", createObj(ofArray([["className", join(" ", ["w-full"])], (elems = [(children_5 = singleton_1(reactElement("tr", {
        children: reactApi.Children.toArray(Array.from(header)),
    })), reactElement("thead", {
        children: reactApi.Children.toArray(Array.from(children_5)),
    })), reactElement("tbody", {
        children: reactApi.Children.toArray(Array.from(rowList)),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function CsvErrorAlert(props) {
    let matchValue;
    return createElement(ErrorAlert, {
        Label: (matchValue = props.CsvError, (matchValue.tag === 1) ? "importer.fail_no_headers" : ((matchValue.tag === 2) ? "importer.fail_headers_not_equal" : "importer.fail_no_rows")),
    });
}

function ImportBusinessUnitSelect(props) {
    if (props.AccountSettings.BusinessUnitsEnabled && (length(props.BusinessUnits) > 0)) {
        return createElement(BusinessUnitSelect, {
            BusinessUnits: props.BusinessUnits,
            FormState: props.FormState,
            OnChange: (option_1) => {
                props.SetSelectedBusinessUnitId(map_1((businessUnit) => (new BusinessUnitId(parse(businessUnit.value.Id))), option_1));
            },
            SelectedBusinessUnitId: unwrap(map_1(BusinessUnitId__get_unwrap, props.SelectedBusinessUnitId)),
        });
    }
    else {
        return defaultOf();
    }
}

function UnknownCategoriesAlert(props) {
    let elems_2, elems_1, elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_2 = [createElement(WarningAlert, {
        Label: "importer.unknown_categories_warning",
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["ml-4", "text-sm"])], (elems_1 = [reactElement("ul", createObj(ofArray([["className", join(" ", ["list-disc", "ml-4"])], (elems = map((name) => reactElement("li", {
        children: name,
    }), props.UnknownCategories), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), Checkbox({
        ComponentState: props.ComponentState,
        IsChecked: props.CreateMissingCategories,
        Label: patternInput[0]("importer.create_missing_categories"),
        OnCheck: props.OnToggle,
        TestId: "create-missing-categories-checkbox",
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function AssignmentFailuresAlert(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", "import-assignment-failures"], ["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_1 = [createElement(WarningAlert, {
        Label: "importer.assignment_failures_warning",
    }), reactElement("ul", createObj(ofArray([["className", join(" ", ["list-disc", "ml-8", "text-sm"])], (elems = map((failure) => reactElement("li", {
        "data-test-id": `import-assignment-failure-${failure.RowIndex}`,
        children: `${t("importer.row")} ${failure.RowIndex} | ${failure.ReceiverName} | ${t(failure.Reason)}`,
    }), props.Failures), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Importer(props) {
    let matchValue_2, importData_3, elems_7;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => init(tupledArg[0], tupledArg[1]), update, (_arg, _arg_1) => {
    }), [props.CurrentUser, props.AccountSettings], undefined);
    const state_1 = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const createMissingCategories = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const uploadedFile = patternInput_2[0];
    const t = useTranslation()[0];
    const isImportActive = props.FormState.IsLoading;
    const componentState = isImportActive ? "disabled" : "enabled";
    const validationMessages = toList_1(props.FormState.Validations);
    const validateWithBusinessUnit = (businessUnitId, file) => {
        const formData = new FormData();
        if (businessUnitId == null) {
        }
        else {
            const businessUnitId_1 = businessUnitId;
            formData.append("businessUnitId", BusinessUnitId__get_unwrap(businessUnitId_1));
        }
        formData.append(file.name, file);
        props.ValidateFormData(formData);
    };
    let alreadyImported;
    const matchValue = props.ImportData;
    alreadyImported = ((matchValue == null) ? false : matchValue.IsImported);
    let hasUnknownCategories;
    const matchValue_1 = props.ImportData;
    hasUnknownCategories = ((matchValue_1 == null) ? false : !isEmpty(matchValue_1.UnknownCategories));
    const canImport = props.IsImportBtnEnabled ? true : ((hasUnknownCategories && ((matchValue_2 = props.ImportData, (matchValue_2 == null) ? false : forAll((tupledArg_1) => {
        if (tupledArg_1[1].ValidationResult.tag === 1) {
            return tupledArg_1[0][1] === "KategorieName";
        }
        else {
            return true;
        }
    }, toList_1(matchValue_2.Rows))))) && !isImportActive);
    let resultAreaData;
    if (!isImportActive) {
        const matchValue_4 = props.ImportData;
        let matchResult, importData_4;
        if (isEmpty(validationMessages)) {
            if (matchValue_4 != null) {
                if ((importData_3 = matchValue_4, (importData_3.CsvErrorImportType == null) && !importData_3.IsImported)) {
                    matchResult = 0;
                    importData_4 = matchValue_4;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                resultAreaData = importData_4;
                break;
            }
            default:
                resultAreaData = undefined;
        }
    }
    else {
        resultAreaData = undefined;
    }
    const matchValue_6 = state_1.UserBusinessUnits;
    if (matchValue_6.tag === 0) {
        return createElement(Skeleton, {
            Variant: "normal",
        });
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_7 = toList(delay(() => {
            let elems_6, elems_1, Title_1, elems_5;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "max-w-[75rem]"])], (elems_6 = [createElement(SectionContainer, {
                Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-6"])], (elems_1 = toList(delay(() => append(singleton(createElement(WarningAlert, {
                    Label: "importer.info_text",
                })), delay(() => {
                    let elems;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-8"])], (elems = [createElement(DownloadFileArea, {
                        CsvFileName: props.CSVFileName,
                        CurrentUserLanguage: props.CurrentUser.Language,
                    }), createElement(UploadArea, {
                        ComponentState: componentState,
                        OnFile: (file_1) => {
                            patternInput_2[1](file_1);
                            validateWithBusinessUnit(state_1.SelectedBusinessUnitId, file_1);
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (props.BusinessUnitSelectEnabled ? singleton(createElement(ImportBusinessUnitSelect, {
                        AccountSettings: props.AccountSettings,
                        BusinessUnits: matchValue_6.fields[0],
                        CurrentUser: props.CurrentUser,
                        FormState: props.FormState,
                        SelectedBusinessUnitId: unwrap(state_1.SelectedBusinessUnitId),
                        SetSelectedBusinessUnitId: (businessUnitId_2) => {
                            let file_2;
                            patternInput[1](new Msg(1, [businessUnitId_2]));
                            let matchResult_1, file_3;
                            if (uploadedFile != null) {
                                if ((file_2 = uploadedFile, !alreadyImported && !isImportActive)) {
                                    matchResult_1 = 0;
                                    file_3 = uploadedFile;
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                            }
                            else {
                                matchResult_1 = 1;
                            }
                            switch (matchResult_1) {
                                case 0: {
                                    validateWithBusinessUnit(businessUnitId_2, file_3);
                                    break;
                                }
                                case 1: {
                                    break;
                                }
                            }
                        },
                    })) : empty_1())));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))),
                Title: props.HeaderTitle,
            }), createElement(SectionContainer, (Title_1 = t("importer.uploaded_data"), {
                Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_5 = toList(delay(() => {
                    let matchValue_7, elems_2;
                    return append((matchValue_7 = props.ImportData, (matchValue_7 == null) ? (empty_1()) : ((!matchValue_7.IsImported && canImport) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_2 = [createElement(Button, {
                        ComponentState: componentState,
                        Label: t("importer.save"),
                        OnClick: () => {
                            props.OnImportData(createMissingCategories);
                        },
                        TestId: "import-save-button",
                        Variant: "primary",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty_1())), delay(() => {
                        let xs_3, elems_3, elems_4;
                        if (isImportActive) {
                            return singleton(createElement(Skeleton, {
                                Variant: "table",
                            }));
                        }
                        else {
                            const matchValue_8 = validationMessages;
                            if (isEmpty(matchValue_8)) {
                                const matchValue_9 = props.ImportData;
                                if (matchValue_9 == null) {
                                    return singleton(createElement(InformationAlert, {
                                        Label: "importer.no_data_imported_msg",
                                    }));
                                }
                                else {
                                    const importData_6 = matchValue_9;
                                    const matchValue_10 = importData_6.CsvErrorImportType;
                                    return (matchValue_10 == null) ? (importData_6.IsImported ? singleton((xs_3 = toList(delay(() => append(singleton(createElement(InformationAlert, {
                                        Label: "importer.successful_imported",
                                    })), delay(() => (!isEmpty(importData_6.AssignmentFailures) ? singleton(createElement(AssignmentFailuresAlert, {
                                        Failures: importData_6.AssignmentFailures,
                                    })) : empty_1()))))), react.createElement(react.Fragment, {}, ...xs_3))) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_3 = toList(delay(() => append(hasUnknownCategories ? singleton(createElement(UnknownCategoriesAlert, {
                                        ComponentState: componentState,
                                        CreateMissingCategories: createMissingCategories,
                                        OnToggle: patternInput_1[1],
                                        UnknownCategories: importData_6.UnknownCategories,
                                    })) : empty_1(), delay(() => singleton(createElement(FailResultArea, {
                                        Data: importData_6,
                                    })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))) : singleton(createElement(CsvErrorAlert, {
                                        CsvError: matchValue_10,
                                    }));
                                }
                            }
                            else {
                                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_4 = toList(delay(() => append(singleton(createElement(ErrorAlert, {
                                    Label: "importer.validation_failed",
                                })), delay(() => map((tupledArg_2) => createElement(WarningAlert, {
                                    Label: tupledArg_2[1],
                                }), matchValue_8))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                            }
                        }
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))),
                Title: unwrap(Title_1),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                const matchValue_11 = resultAreaData;
                if (matchValue_11 == null) {
                    return empty_1();
                }
                else {
                    return singleton(createElement(ResultArea, {
                        Data: matchValue_11,
                    }));
                }
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
    }
}

